import { gql } from '@apollo/client';

// Organization queries
export const ORGANIZATION_GQL = gql`
  query OrganizationQuery($organization_id: uuid!) {
    organization: organization_by_pk(id: $organization_id) {
      id
      name
    }
  }
`;

export const ORG_LIST_QUERY = gql`
  query OrgManagementPage_OrgList {
    organization(order_by: { name: asc }) {
      id
      name
    }
  }
`;

// Organization users queries
export const ORGANIZATION_USERS_GQL = gql`
  query orgUsersTab_getUsers($organization_id: uuid!) {
    barns: farm(
      where: { organization_id: { _eq: $organization_id }, deleted_at: { _is_null: true } }
      order_by: { name: asc }
    ) {
      id
      name
    }
    roles(
      where: { _or: [{ organization_id: { _eq: $organization_id } }, { organization_id: { _is_null: true } }] }
      order_by: { name: asc }
    ) {
      id
      name
    }
    barn_users: user_barn(
      where: { barn: { deleted_at: { _is_null: true }, organization_id: { _eq: $organization_id } } }
      order_by: { user: { name: asc } }
    ) {
      created_at
      updated_at
      deleted_at
      role {
        name
        id
      }
      barn {
        id
        name
      }
      user_barn_notification_tier_assignment {
        id
        tier_id
      }
      user {
        id
        name
        email
        phone_number
        avatar
        invites_to {
          accepted_at
        }
        user_notification_transport_settings {
          sms
          email
          push
        }
        push_notification_tokens {
          phone_info
        }
        sms_statuses: messages(
          where: { transported_as: { _eq: "sms" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
        email_statuses: messages(
          where: { transported_as: { _eq: "email" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
        push_statuses: messages(
          where: { transported_as: { _eq: "push" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
      }
    }
    organization_users: user_organization(
      where: { organization_id: { _eq: $organization_id } }
      order_by: { user: { name: asc } }
    ) {
      created_at
      updated_at
      deleted_at
      role {
        name
        id
      }
      user_organization_notification_tier_assignment {
        id
        tier_id
      }
      user {
        id
        name
        email
        phone_number
        avatar
        invites_to {
          accepted_at
        }
        user_notification_transport_settings {
          sms
          email
          push
        }
        push_notification_tokens {
          phone_info
        }
        sms_statuses: messages(
          where: { transported_as: { _eq: "sms" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
        email_statuses: messages(
          where: { transported_as: { _eq: "email" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
        push_statuses: messages(
          where: { transported_as: { _eq: "push" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
      }
    }
    barn_tier_assignments: user_barn_notification_tier_assignment(
      where: { barn: { organization_id: { _eq: $organization_id }, deleted_at: { _is_null: true } } }
    ) {
      id
      tier_id
      barn_id
      user_id
      barn {
        id
        name
      }
      user {
        id
        name
        email
        phone_number
        avatar
        invites_to {
          accepted_at
        }
        user_notification_transport_settings {
          sms
          email
          push
        }
        push_notification_tokens {
          phone_info
        }
        sms_statuses: messages(
          where: { transported_as: { _eq: "sms" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
        email_statuses: messages(
          where: { transported_as: { _eq: "email" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
        push_statuses: messages(
          where: { transported_as: { _eq: "push" }, deleted_at: { _is_null: true } }
          limit: 1
          order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
        ) {
          id
          status
        }
      }
    }
  }
`;

export const GET_ORG_PLAN_GQL = gql`
  query getOrganizationPlan($org_id: uuid!) {
    organization_notification_plan(where: { organization_id: { _eq: $org_id } }) {
      plan_id
      organization_id
      plan {
        name
        tiers {
          id
          name
          sort_order
        }
      }
    }
  }
`;

export const UPSERT_USER_BARN_TIER_ASSIGNMENT_GQL = gql`
  mutation UpsertUserBarnTierAssignment($objects: [user_barn_notification_tier_assignment_insert_input!]!) {
    insert_user_barn_notification_tier_assignment(
      objects: $objects
      on_conflict: { constraint: user_barn_notification_tier_assignment_unique, update_columns: [tier_id] }
    ) {
      affected_rows
    }
  }
`;

export const UPSERT_USER_ORGANIZATION_TIER_ASSIGNMENT_GQL = gql`
  mutation UpsertUserOrganizationTierAssignment(
    $objects: [user_organization_notification_tier_assignment_insert_input!]!
  ) {
    insert_user_organization_notification_tier_assignment(
      objects: $objects
      on_conflict: { constraint: user_organization_notification_tier_assignment_unique, update_columns: [tier_id] }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_USER_ORGANIZATION_TIER_ASSIGNMENT_GQL = gql`
  mutation DeleteUserOrganizationTierAssignment($id: uuid!) {
    delete_user_organization_notification_tier_assignment(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const DELETE_USER_BARN_TIER_ASSIGNMENT_GQL = gql`
  mutation DeleteUserBarnTierAssignment($id: uuid!) {
    delete_user_barn_notification_tier_assignment(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const UPSERT_USER_BARN_GQL = gql`
  mutation OrgUsersTab_UpsertUserBarn($objects: [user_barn_insert_input!]!) {
    insert_user_barn(
      objects: $objects
      on_conflict: { constraint: user_barn_pkey, update_columns: [deleted_at, role_id] }
    ) {
      affected_rows
    }
  }
`;

export const UPSERT_USER_ORGANIZATION_ACCESS_GQL = gql`
  mutation OrgUsersTab_UpsertUserOrganization($objects: [user_organization_insert_input!]!) {
    insert_user_organization(
      objects: $objects
      on_conflict: { constraint: user_organization_pkey, update_columns: [deleted_at, role_id] }
    ) {
      affected_rows
    }
  }
`;

export const SOFT_DELETE_USER_BARN_GQL = gql`
  mutation softDeleteUserBarn($user_id: uuid!, $barn_id: uuid!, $role_id: uuid!, $now: bigint) {
    update_user_barn(
      where: { user_id: { _eq: $user_id }, barn_id: { _eq: $barn_id }, role_id: { _eq: $role_id } }
      _set: { deleted_at: $now }
    ) {
      affected_rows
      returning {
        deleted_at
      }
    }
    delete_user_barn_notification_tier_assignment(where: { user_id: { _eq: $user_id }, barn_id: { _eq: $barn_id } }) {
      affected_rows
    }
  }
`;

export const SOFT_DELETE_USER_ORGANIZATION_GQL = gql`
  mutation softDeleteUserOrganization($user_id: uuid!, $organization_id: uuid!, $role_id: uuid!, $now: bigint) {
    update_user_organization(
      where: { user_id: { _eq: $user_id }, organization_id: { _eq: $organization_id }, role_id: { _eq: $role_id } }
      _set: { deleted_at: $now }
    ) {
      affected_rows
      returning {
        deleted_at
      }
    }
  }
`;

export const REACTIVATE_USER_ORGANIZATION_GQL = gql`
  mutation reactivateUserOrganization($user_id: uuid!, $organization_id: uuid!, $role_id: uuid!) {
    update_user_organization(
      where: { user_id: { _eq: $user_id }, organization_id: { _eq: $organization_id }, role_id: { _eq: $role_id } }
      _set: { deleted_at: null }
    ) {
      affected_rows
      returning {
        deleted_at
      }
    }
  }
`;

// Organization barns tab queries
export const ORG_BARNS_QUERY = gql`
  query OrgBarnsTab_Barns($id: uuid!) {
    organization_by_pk(id: $id) {
      id
      name
      barns: farms(where: { deleted_at: { _is_null: true } }, order_by: { name: asc }) {
        id
        is_simulated
        name
        feed_lines_aggregate(where: { deleted_at: { _is_null: true } }) {
          aggregate {
            count
          }
        }
        rooms_aggregate(where: { deleted_at: { _is_null: true } }) {
          aggregate {
            count
          }
        }
        bins_aggregate(where: { deleted_at: { _is_null: true } }) {
          aggregate {
            count
          }
        }
        feed_lines(where: { deleted_at: { _is_null: true } }) {
          device_assignments_aggregate(
            where: { deleted_at: { _is_null: true }, ended_at: { _is_null: true } }
          ) {
            aggregate {
              count
            }
          }
        }
        bin_sets(where: { deleted_at: { _is_null: true } }) {
          bin_controllers_aggregate(where: { deleted_at: { _is_null: true } }) {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
`;

export const GET_NOTIFICATION_TIER_PLANS_GQL = gql`
  query GetNotificationTierPlans($org_id: uuid) {
    notification_tier_plan(
      where: { _or: [{ organization_id: { _eq: $org_id } }, { organization_id: { _is_null: true } }] }
      order_by: { name: asc }
    ) {
      id
      name
      description: public_description
      organization_id
    }
  }
`;
export const GET_NOTIFICATION_PLAN_AND_TIERS_GQL = gql`
  query GetNotificationPlanAndTiers($plan_id: uuid!) {
    plan: notification_plan_by_pk(id: $plan_id) {
      id
      name
      tiers {
        id
        sort_order
        name
        description: public_description
        editable
        default_fault_settings {
          code
          enabled
          alert_threshold_type
          alert_threshold_seconds
          renotify_enabled
          renotify_threshold_seconds
          notify_on_resolved
        }
      }
    }
  }
`;

export const GET_ORG_NOTIFICATION_PLAN_GQL = gql`
  query GetOrgNotificationPlan($org_id: uuid!) {
    plans: organization_notification_plan(where: { organization_id: { _eq: $org_id } }) {
      plan_id
    }
  }
`;

export const GET_ORG_NOTIFICATION_SETTINGS_GQL = gql`
  query GetOrgNotificationSettings($org_id: uuid!) {
    plans: organization_notification_plan(where: { organization_id: { _eq: $org_id } }) {
      plan_id
    }
    organization_notification_settings: organization_fault_notification_tier_settings_view(
      where: { organization_id: { _eq: $org_id } }
    ) {
      tier {
        id
        sort_order
        name
        description: public_description
        editable
      }
      plan_id
      code
      enabled
      alert_threshold_type
      alert_threshold_seconds
      renotify_enabled
      renotify_threshold_seconds
      notify_on_resolved
    }
  }
`;

export const GET_ORG_NOTIFICATION_SETTINGS_BY_PLAN_GQL = gql`
  query GetOrgNotificationSettingsByPlan($org_id: uuid!, $plan_id: uuid!) {
    organization_notification_settings: organization_fault_notification_tier_settings_view(
      where: { organization_id: { _eq: $org_id }, plan_id: { _eq: $plan_id } }
    ) {
      tier {
        id
        sort_order
        name
        description: public_description
        editable
      }
      plan_id
      code
      enabled
      alert_threshold_type
      alert_threshold_seconds
      renotify_enabled
      renotify_threshold_seconds
      notify_on_resolved
    }
  }
`;

export const GET_BARN_OVERRIDES_GQL = gql`
  query GetOrgBarnOverrides($org_id: uuid!, $plan_id: uuid!) {
    farm(
      where: {
        _and: [
          { organization_id: { _eq: $org_id } }
          { direct_fault_notification_tier_settings: { tier: { notification_plan_id: { _eq: $plan_id } } } }
        ]
      }
    ) {
      id
      name
      fault_notification_settings: direct_fault_notification_tier_settings(
        where: { tier: { notification_plan_id: { _eq: $plan_id } } }
        order_by: { tier: { sort_order: desc } }
      ) {
        tier {
          id
          sort_order
          name
          description: public_description
          editable
        }
        code
        enabled
        alert_threshold_type
        alert_threshold_seconds
        renotify_enabled
        renotify_threshold_seconds
        notify_on_resolved
      }
    }
  }
`;

export const UPSERT_ORG_NOTIFICATION_PLAN_GQL = gql`
  mutation UpsertOrgNotificationPlan($org_id: uuid!, $notification_tier_plan_id: uuid!) {
    insert_organization_notification_plan(
      objects: { organization_id: $org_id, plan_id: $notification_tier_plan_id }
      on_conflict: { constraint: organization_notification_plan_unique, update_columns: [plan_id] }
    ) {
      affected_rows
      returning {
        plan_id
      }
    }
  }
`;

export const GET_NOTIFICATION_TIERS_FOR_PLAN_GQL = gql`
  query GetNotificationTiersForPlan($plan_id: uuid!) {
    notification_tier(where: { notification_plan_id: { _eq: $plan_id } }, order_by: { sort_order: desc }) {
      id
      name
      description: public_description
      sort_order
      editable
    }
  }
`;

export const UPSERT_BARN_FAULT_NOTIFICATION_TIER_SETTINGS_GQL = gql`
  mutation UpsertBarnFaultNotificationTierSettings($objects: [fault_barn_notification_tier_settings_insert_input!]!) {
    insert_fault_barn_notification_tier_settings(
      objects: $objects
      on_conflict: {
        constraint: fault_barn_notification_tier_settings_unique
        update_columns: [
          enabled
          alert_threshold_seconds
          alert_threshold_type
          renotify_enabled
          renotify_threshold_seconds
          notify_on_resolved
        ]
      }
    ) {
      affected_rows
    }
  }
`;

export const UPSERT_ORG_FAULT_NOTIFICATION_TIER_SETTINGS_GQL = gql`
  mutation UpsertOrgFaultNotificationTierSettings(
    $objects: [fault_organization_notification_tier_settings_insert_input!]!
  ) {
    insert_fault_organization_notification_tier_settings(
      objects: $objects
      on_conflict: {
        constraint: fault_organization_notification_tier_settings_unique
        update_columns: [
          enabled
          alert_threshold_seconds
          alert_threshold_type
          renotify_enabled
          renotify_threshold_seconds
          notify_on_resolved
        ]
      }
    ) {
      affected_rows
    }
  }
`;

// Additional queries for OrgTierSettingsPage
export const GET_ORG_BARNS_GQL = gql`
  query GetOrgBarns($organization_id: uuid!) {
    farm(
      where: { organization_id: { _eq: $organization_id }, deleted_at: { _is_null: true } }
      order_by: { name: asc }
    ) {
      id
      name
    }
  }
`;

export const DELETE_FAULT_NOTIFICATION_TIER_SETTINGS_GQL = gql`
  mutation DeleteFaultNotificationTierSettings($tier_id: uuid!, $barn_id: uuid) {
    delete_fault_barn_notification_tier_settings(
      where: { notification_tier_id: { _eq: $tier_id }, barn_id: { _eq: $barn_id } }
    ) {
      affected_rows
    }
  }
`;

// User transport settings queries
export const GET_USER_NOTIFICATION_TRANSPORT_SETTINGS_GQL = gql`
  query GetUserNotificationTransportSettings($user_ids: [uuid!]!) {
    user_notification_transport_settings(where: { user_id: { _in: $user_ids } }) {
      user_id
      sms
      push
      email
    }
  }
`;
